import React, { useEffect, useState } from 'react';
import * as Images from '../../assets';
import { Grid, Tooltip } from '@mui/material';
import {
  AppRegistration,
  CheckCircle,
  FmdGoodOutlined,
  Layers,
  LocationOnOutlined,
  NotificationsActive,
} from '@mui/icons-material';
import { LightBlueButton } from '../../components';
import { Link } from 'react-router-dom';
import { routesName } from '../../constants/routes-name';
import { useSelector } from 'react-redux';
import { ApiManager } from '../../services/api';
import ActiveTendersMap from './ActiveTendersMap';

const ActiveTenderNotifications = () => {
  const { user } = useSelector(({ user }) => user);
  const [latLng, setLatLng] = useState([]);

  const getLatLng = async () => {
    const res = await ApiManager.getLatLng();
    if (res?.status === 200 && res?.data?.result) {
      setLatLng(res.data.result);
    }
  };

  useEffect(() => {
    getLatLng();
  }, []);

  const activeTenders = [
    { id: '', top: '19%', left: '50%' },
    { id: '', top: '32%', left: '53%' },
    { id: '', top: '64%', left: '30%' },
    { id: '', top: '45%', left: '60%' },
    { id: '', top: '45.5%', left: '62%' },
    { id: '', top: '48%', left: '64%' },
    { id: '', top: '49%', left: '66%' },
    { id: '', top: '47%', left: '68%' },
    { id: '', top: '33%', left: '78%' },
    { id: '', top: '32%', left: '55%' },
    { id: '', top: '30%', left: '54%' },
    { id: '', top: '31.3%', left: '53%' },
    { id: '', top: '32.4%', left: '52%' },
    { id: '', top: '31%', left: '51%' },
    { id: '', top: '31%', left: '48%' },
    { id: '', top: '34%', left: '49%' },
    { id: '', top: '33%', left: '48%' },
    { id: '', top: '36%', left: '47%' },
    { id: '', top: '33%', left: '46%' },
    { id: '', top: '35%', left: '46%' },
    { id: '', top: '34%', left: '48%' },
    { id: '', top: '37%', left: '56%' },
    { id: '', top: '67%', left: '77%' },
    { id: '', top: '50%', left: '70%' },
    { id: '', top: '54%', left: '65.3%' },
    { id: '', top: '14%', left: '34%' },
    { id: '', top: '13%', left: '35%' },
    { id: '', top: '48%', left: '58%' },
    { id: '', top: '49%', left: '43%' },
    { id: '', top: '50%', left: '44%' },
    { id: '', top: '50%', left: '51%' },
    { id: '', top: '60%', left: '53%' },
    { id: '', top: '51%', left: '46%' },
    { id: '', top: '51%', left: '49%' },
    { id: '', top: '51%', left: '52%' },
    { id: '', top: '62%', left: '54%' },
    { id: '', top: '60%', left: '53%' },
    { id: '', top: '59%', left: '52%' },
    { id: '', top: '53%', left: '44%' },
    { id: '', top: '54%', left: '46%' },
    { id: '', top: '55%', left: '45%' },
  ];

  return (
    <div
      style={{
        backgroundImage: `url('${Images.homePage7}')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed',
        transition:
          'background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s',
      }}
    >
      <div
        className="h-full w-full flex justify-center flex-col items-center gap-6 lg:py-24 md:py-16 py-12 lg:px-12 md:px-8 px-6 text-white"
        style={{
          backgroundColor: 'transparent',
          backgroundImage:
            'radial-gradient(at center center, var(--dark-blue) 23%, black 100%)',
          opacity: '0.86',
          transition: 'background 0.3s, border-radius 0.3s, opacity 0.3s',
        }}
      >
        <div className="space-y-8 w-full">
          <div className="flex justify-center items-center text-5xl font-bold text-center">
            Active Tender Notifications
          </div>

          <div className="mx-auto container">
            <div className="tender-map ">
              <img src={Images.homePage6} />

              {activeTenders.map((item, index) => (
                <Link to={routesName.pricing}>
                  <LocationOnOutlined
                    key={index}
                    sx={{ fontSize: '8px', color: 'red' }}
                    className="map-point"
                    style={{
                      top: item?.top || '50%',
                      left: item?.left || '50%',
                    }}
                  />
                </Link>
              ))}

              {/* <button class="map-point" style={{ top: '15%', left: '35%' }}>
                <div class="content">
                  <div class="centered-y">
                    <h2>A Place</h2>
                    <p>
                      You can put plenty of details in here. In the original, I
                      listed contact information and linked phone numbers and
                      email addresses.
                    </p>
                  </div>
                </div>
              </button> */}
            </div>
          </div>

          {/* <div className="mx-auto container w-full">
            <ActiveTendersMap
              position={{ lat: 40.505, lng: -0.09 }}
              tenders={latLng}
            />
          </div> */}

          <div className="flex justify-center items-center gap-3">
            {
              <Link to={routesName.pricing}>
                <LightBlueButton size="large" sx={{ fontSize: '12px' }}>
                  Get Started
                </LightBlueButton>
              </Link>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActiveTenderNotifications;
